import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { LookupsService } from '../../services/lookups.service';
import { Patterns } from '../../helpers/patterns';

@Component({
  selector: 'app-phone-input',
  templateUrl: './phone-input.component.html',
  styles: ``
})
export class PhoneInputComponent implements OnInit {

  @Input() form!: FormGroup;
  @Input() control!: string;
  @Input() codeControl!: string;
  @Input() label!: string;
  @Input() isSubmitted: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() icon!: string;

  selectedCountry: any;
  countryCodes: any[] = [];
  loading: boolean = false;

  constructor(private _lookupService: LookupsService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getCountryCodes();
  }

  ngAfterViewChecked() {
    this.cdr.detectChanges();
  }

  selectChangeed(event: any) {
    this.selectedCountry = this.countryCodes.filter(item => item.code == event.value)[0];
    // this.form.get(this.control)?.patchValue(null);
    this.updatePhoneValidators();
  }

  getCountryCodes() {
    this.loading = true
    this._lookupService.getPhoneCodes().subscribe((res: any) => {
      this.loading = false;
      this.countryCodes = res.data;
      if (this.form.value[this.codeControl]) {
        this.selectedCountry = this.countryCodes.filter(item => item.code == this.form.value[this.codeControl])[0];
      } else {
        this.selectedCountry = this.countryCodes.filter(item => item.code == '+966')[0];
        this.form.get(this.codeControl)?.patchValue('+966');
      }
    })
  }


  updatePhoneValidators() {
    const phoneCtrl = this.form.get(this.control)!;
    const length = this.selectedCountry.length;
    const prefix = this.selectedCountry.startsWith;

    const validators: ValidatorFn[] = [];

    if (this.isRequired) {
      validators.push(Validators.required);
    }

    validators.push((ctrl: AbstractControl): ValidationErrors | null => {
      const v = (ctrl.value || '') as string;
      if (!v) return null;
      return v.length < length ? { minlength: { requiredLength: length, actualLength: v.length } } : null;
    });

    validators.push((ctrl: AbstractControl): ValidationErrors | null => {
      const v = (ctrl.value || '') as string;
      if (!v) return null;
      return v.length > length ? { maxlength: { requiredLength: length, actualLength: v.length } } : null;
    });

    validators.push((ctrl: AbstractControl): ValidationErrors | null => {
      const v = (ctrl.value || '') as string;
      if (!v) return null;
      return v.startsWith(prefix) ? null : { startsWith: { requiredPrefix: prefix, actual: v } };
    });

    phoneCtrl.setValidators(validators);
    phoneCtrl.updateValueAndValidity();
  }

  hasError(controlName: string, errorCode: string) {
    const ctrl = this.form.get(controlName);
    if (!ctrl) return false;
    if ((errorCode === 'minlength' || errorCode === 'startsWith') && !ctrl.value) {
      return false;
    }
    return (ctrl.touched || ctrl.dirty) && ctrl.hasError(errorCode);
  }


}
